/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scrape_Router_Step_BrowserInputs */

const en_scrape_router_step_browser = /** @type {(inputs: Scrape_Router_Step_BrowserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full browser`)
};

const zh_hans1_scrape_router_step_browser = /** @type {(inputs: Scrape_Router_Step_BrowserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完整浏览器`)
};

const pt_br2_scrape_router_step_browser = /** @type {(inputs: Scrape_Router_Step_BrowserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegador completo`)
};

const es_scrape_router_step_browser = /** @type {(inputs: Scrape_Router_Step_BrowserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegador completo`)
};

const fr_scrape_router_step_browser = /** @type {(inputs: Scrape_Router_Step_BrowserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigateur complet`)
};

const de_scrape_router_step_browser = /** @type {(inputs: Scrape_Router_Step_BrowserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollständiger Browser`)
};

const ru_scrape_router_step_browser = /** @type {(inputs: Scrape_Router_Step_BrowserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Полноценный браузер`)
};

const it_scrape_router_step_browser = /** @type {(inputs: Scrape_Router_Step_BrowserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browser completo`)
};

/**
* | output |
* | --- |
* | "Full browser" |
*
* @param {Scrape_Router_Step_BrowserInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const scrape_router_step_browser = /** @type {((inputs?: Scrape_Router_Step_BrowserInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scrape_Router_Step_BrowserInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_scrape_router_step_browser(inputs)
	if (locale === "pt-BR") return pt_br2_scrape_router_step_browser(inputs)
	if (locale === "es") return es_scrape_router_step_browser(inputs)
	if (locale === "fr") return fr_scrape_router_step_browser(inputs)
	if (locale === "de") return de_scrape_router_step_browser(inputs)
	if (locale === "ru") return ru_scrape_router_step_browser(inputs)
	if (locale === "it") return it_scrape_router_step_browser(inputs)
	return en_scrape_router_step_browser(inputs)
});